/* eslint-disable object-curly-newline */
import { WriterLevels, PackageTypes } from '../enums';

const { COMPACT, COMPLETE, NOVELLA } = PackageTypes;
const { JUNIOR, SENIOR, PREMIUM } = WriterLevels;
const feeOptions = { withAI: 'withAI', withoutAI: 'withoutAI' };
const countriesForProject = { gb: 'gb', us: 'us', nl: 'nl' };
const defaultCountry = countriesForProject.gb;

const PROJECT_FEE = {
  [feeOptions.withoutAI]: {
    us: {
      [COMPACT]: { [JUNIOR]: 600, [SENIOR]: 860, [PREMIUM]: 1125 },
      [COMPLETE]: { [JUNIOR]: 1000, [SENIOR]: 1440, [PREMIUM]: 1875 },
      [NOVELLA]: { [JUNIOR]: 0, [SENIOR]: 2300, [PREMIUM]: 3000 },
    },
    nl: {
      [COMPACT]: { [JUNIOR]: 600, [SENIOR]: 900, [PREMIUM]: 0 },
      [COMPLETE]: { [JUNIOR]: 1000, [SENIOR]: 1500, [PREMIUM]: 0 },
      [NOVELLA]: { [JUNIOR]: 0, [SENIOR]: 2400, [PREMIUM]: 0 },
    },
    gb: {
      [COMPACT]: { [JUNIOR]: 450, [SENIOR]: 600, [PREMIUM]: 750 },
      [COMPLETE]: { [JUNIOR]: 750, [SENIOR]: 1000, [PREMIUM]: 1250 },
      [NOVELLA]: { [JUNIOR]: 0, [SENIOR]: 1600, [PREMIUM]: 2000 },
    },
  },
  [feeOptions.withAI]: {
    us: {
      [COMPACT]: { [JUNIOR]: 300, [SENIOR]: 430, [PREMIUM]: 563 },
      [COMPLETE]: { [JUNIOR]: 500, [SENIOR]: 720, [PREMIUM]: 938 },
      [NOVELLA]: { [JUNIOR]: 0, [SENIOR]: 1150, [PREMIUM]: 1500 },
    },
    nl: {
      [COMPACT]: { [JUNIOR]: 600, [SENIOR]: 900, [PREMIUM]: 0 },
      [COMPLETE]: { [JUNIOR]: 1000, [SENIOR]: 1500, [PREMIUM]: 0 },
      [NOVELLA]: { [JUNIOR]: 0, [SENIOR]: 2400, [PREMIUM]: 0 },
    },
    gb: {
      [COMPACT]: { [JUNIOR]: 225, [SENIOR]: 300, [PREMIUM]: 375 },
      [COMPLETE]: { [JUNIOR]: 375, [SENIOR]: 500, [PREMIUM]: 625 },
      [NOVELLA]: { [JUNIOR]: 0, [SENIOR]: 800, [PREMIUM]: 1000 },
    },
  },
};

const getDefaultFee = (options) => {
  const {
    packageType,
    writerLevel,
    country = defaultCountry,
    isAiProject = false,
  } = options;

  const selectedCustomerCountry = countriesForProject[country] || defaultCountry;
  let feesByProjectSettings;
  if (isAiProject) feesByProjectSettings = PROJECT_FEE[feeOptions.withAI];
  else feesByProjectSettings = PROJECT_FEE[feeOptions.withoutAI];

  return feesByProjectSettings[selectedCustomerCountry]?.[packageType]?.[writerLevel] || 0;
};

export default getDefaultFee;
